export default __webpack_public_path__ + "static/media/ascending-active.df81df99.svg";